import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getSignedMonetaryValue } from 'src/utils/typeFormaters';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
// import { getBank, SelectMenu } from '@livable/saas-react-components';
import { Button, LinearProgress,
// MenuItem,
Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs
// TextField,
} from '@mui/material';
import { useStore } from 'src/stores';
// import MonthRangeDatePicker from 'src/components/general/MonthRangeDatePicker';
import Row from './tableRow';
import useStyles from './styles';
import { structureInvoiceItems } from 'src/stores/invoice';
const InvoicesTab = observer(() => {
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;

  // const methods = [
  //   ...new Map(
  //     store.invoice.invoices
  //       .map(invoice => ({
  //         brand: invoice.brand,
  //         card: `${invoice.brand}${invoice.last4}`,
  //         last4: invoice.last4,
  //       }))
  //       .map(item => [item.card, item])
  //   ).values(),
  // ];

  // const [dates, setDates] = useState({
  //   fromDate: '',
  //   toDate: '',
  // });
  // const [fetched, setFetched] = useState(false);
  // const [method, setMethod] = useState('All');
  // const [searchValue, setSearchValue] = useState('');
  // const [status, setStatus] = useState('All');
  const _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    propertiesRespData = _useState2[0],
    setPropertiesRespData = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    upcomingData = _useState4[0],
    setUpcomingData = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showIsLoad = _useState6[0],
    setShowIsLoad = _useState6[1];
  const _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    newInvoicesData = _useState8[0],
    setNewInvoicesData = _useState8[1];
  const getInvoices = async () => {
    var _resp$response, _resp$response2;
    const resp = await store.invoice.getInvoicesV2Async.run({
      startingAfter: null,
      endingBefore: null,
      pageSize: 15
    });
    if ((resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 || (_resp$response = _resp$response.invoices) === null || _resp$response === void 0 ? void 0 : _resp$response.length) === 15 && resp !== null && resp !== void 0 && (_resp$response2 = resp.response) !== null && _resp$response2 !== void 0 && _resp$response2.hasMore) setShowIsLoad(true);
    return resp === null || resp === void 0 ? void 0 : resp.response;
  };
  const getUpcomingInvoices = async () => {
    const resp = await store.invoice.getUpcomingInvoicesAsync.run();
    return resp === null || resp === void 0 ? void 0 : resp.response;
  };
  const getInvoicesNew = async () => {
    const resp = await store.stripe.getInvoicesAsync.run();
    return resp === null || resp === void 0 ? void 0 : resp.response;
  };
  const getUpcomingInvoicesNew = async () => {
    const resp = await store.stripe.getUpcomingInvoicesAsync.run();
    return resp === null || resp === void 0 ? void 0 : resp.response;
  };
  useEffect(() => {
    (async () => {
      const getUpcomingInvoicesResp = store.account.featureFlagsStore.getIsStripeInvoicingApiEnabled ? await getUpcomingInvoicesNew() : await getUpcomingInvoices();
      const propertiesResp = await store.company.getCompanyPropertiesAsync.run();
      const data = {};
      propertiesResp.response.map(i => {
        data[i.propertyId] = i.address;
      });
      const getUpcomingInvoicesRespData = getUpcomingInvoicesResp === null || getUpcomingInvoicesResp === void 0 ? void 0 : getUpcomingInvoicesResp.map(i => _objectSpread(_objectSpread({}, i), {}, {
        amountPaid: getSignedMonetaryValue(i.amountPaid),
        amountRefunded: getSignedMonetaryValue(i.amountRefunded),
        id: uuid(),
        invoiceItems: store.account.featureFlagsStore.getIsStripeInvoicingApiEnabled ? i.invoiceItems : structureInvoiceItems(i.invoiceItems),
        periodEnd: moment(i.periodEnd).format('MM/DD/YYYY'),
        periodName: i.periodEnd ? moment(i.periodEnd).format('MMMM YYYY') : '-',
        periodStart: moment(i.periodStart).format('MM/DD/YYYY')
      })).sort((a, b) => {
        if (moment(a.periodEnd).isBefore(moment(b.periodEnd))) return -1;
        return 1;
      }).reverse();
      setUpcomingData(getUpcomingInvoicesRespData);
      setPropertiesRespData(data);
      if (store.account.featureFlagsStore.getIsStripeInvoicingApiEnabled) {
        const getNewInvoicesResp = await getInvoicesNew();
        const getNewInvoicesRespData = getNewInvoicesResp === null || getNewInvoicesResp === void 0 ? void 0 : getNewInvoicesResp.map(i => _objectSpread(_objectSpread({}, i), {}, {
          amountPaid: getSignedMonetaryValue(i.amountPaid),
          amountRefunded: getSignedMonetaryValue(i.amountRefunded),
          id: uuid(),
          invoiceItems: i.invoiceItems,
          periodEnd: moment(i.periodEnd).format('MM/DD/YYYY'),
          periodName: i.periodEnd ? moment(i.periodEnd).format('MMMM YYYY') : '-',
          periodStart: moment(i.periodStart).format('MM/DD/YYYY')
        })).sort((a, b) => {
          if (moment(a.periodEnd).isBefore(moment(b.periodEnd))) return -1;
          return 1;
        }).reverse();
        setNewInvoicesData(getNewInvoicesRespData);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   if (!fetched) return;

  //   let filtered = [
  //     ...store.invoice.invoices.filter(i => {
  //       let invoice = { ...i };

  //       invoice.billPeriod = `${invoice.periodStart} - ${invoice.periodEnd}`;
  //       delete invoice.id;
  //       delete invoice.invoiceLink;
  //       delete invoice.invoiceItems;
  //       delete invoice.periodEnd;
  //       delete invoice.periodStart;

  //       let keys = Object.values(invoice);
  //       return keys.some(val => val && val.toLowerCase().includes(searchValue));
  //     }),
  //   ];

  //   if (status !== 'All') {
  //     filtered = filtered.filter(invoice => invoice.status === status);
  //   }

  //   if (method === 'Bank card') {
  //     filtered = filtered.filter(invoice => invoice.last4 === null);
  //   } else if (method !== 'All') {
  //     filtered = filtered.filter(invoice => `${invoice.brand}${invoice.last4}` === method);
  //   }

  //   filtered = filtered.filter(
  //     invoice =>
  //       moment(dates.fromDate).isSameOrBefore(moment(invoice.periodEnd)) &&
  //       moment(invoice.periodStart).isSameOrBefore(moment(dates.toDate))
  //   );

  //   store.invoice.setFilteredInvoices(filtered);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [dates, method, searchValue, status]);

  // const handleDateChange = (fromDate, toDate) => setDates({ fromDate, toDate });
  // const handleMethodChange = event => setMethod(event.target.value);
  // const handleStatusChange = event => setStatus(event.target.value);

  const _useState9 = useState('upcoming'),
    _useState0 = _slicedToArray(_useState9, 2),
    selectedTab = _useState0[0],
    setSelectedTab = _useState0[1];
  const handleTabChange = async (e, newValue) => {
    setSelectedTab(newValue);
    if (newValue === 'other') {
      getInvoices().then(async () => {
        const propertiesResp = await store.company.getCompanyPropertiesAsync.run();
        const data = {};
        propertiesResp.response.map(i => {
          data[i.propertyId] = i.address;
        });
        setPropertiesRespData(data);
      });
    }
  };
  const loadMore = async () => {
    var _resp$response3, _resp$response4;
    setShowIsLoad(false);
    const lastInvoice = store.invoice.filteredInvoices[store.invoice.filteredInvoices.length - 1];
    const resp = await store.invoice.getInvoicesV2LoadMoreAsync.run({
      startingAfter: lastInvoice ? lastInvoice.stripeInvoiceId : null,
      pageSize: 15
    });
    if ((resp === null || resp === void 0 || (_resp$response3 = resp.response) === null || _resp$response3 === void 0 || (_resp$response3 = _resp$response3.invoices) === null || _resp$response3 === void 0 ? void 0 : _resp$response3.length) === 15 && resp !== null && resp !== void 0 && (_resp$response4 = resp.response) !== null && _resp$response4 !== void 0 && _resp$response4.hasMore) setShowIsLoad(true);
  };
  return /*#__PURE__*/React.createElement("div", null, (store.stripe.getInvoicesAsync.inProgress || store.invoice.getInvoicesV2Async.inProgress || store.stripe.getUpcomingInvoicesAsync.inProgress || store.invoice.getUpcomingInvoicesAsync.inProgress || store.company.getCompanyPropertiesAsync.inProgress) && /*#__PURE__*/React.createElement("div", {
    className: classes.loader
  }, /*#__PURE__*/React.createElement(LinearProgress, null)), !(store.stripe.getInvoicesAsync.inProgress || store.invoice.getInvoicesV2Async.inProgress || store.stripe.getUpcomingInvoicesAsync.inProgress || store.invoice.getUpcomingInvoicesAsync.inProgress || store.company.getCompanyPropertiesAsync.inProgress) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.tabsWrapper
  }, /*#__PURE__*/React.createElement(Tabs, {
    onChange: handleTabChange,
    value: selectedTab
  }, /*#__PURE__*/React.createElement(Tab, {
    label: "Upcoming",
    value: 'upcoming'
  }), /*#__PURE__*/React.createElement(Tab, {
    label: "Other",
    value: 'other'
  }))), selectedTab === 'upcoming' && /*#__PURE__*/React.createElement(React.Fragment, null, (upcomingData === null || upcomingData === void 0 ? void 0 : upcomingData.length) === 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.notFound
  }, t('No upcoming found')), upcomingData && (upcomingData === null || upcomingData === void 0 ? void 0 : upcomingData.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.buildingsList
  }, /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null), /*#__PURE__*/React.createElement(TableCell, null, t('subscriptions.period_header')), /*#__PURE__*/React.createElement(TableCell, null, t('subscriptions.bill_period_header')), !store.account.featureFlagsStore.getIsStripeInvoicingApiEnabled && /*#__PURE__*/React.createElement(TableCell, null, t('subscriptions.invoice_number_header')), /*#__PURE__*/React.createElement(TableCell, null, t('subscriptions.payment_method_header')), /*#__PURE__*/React.createElement(TableCell, null, t('subscriptions.status_header')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('subscriptions.amount_header')), !store.account.featureFlagsStore.getIsStripeInvoicingApiEnabled && /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('subscriptions.refunded_header')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('subscriptions.toolbox')))), /*#__PURE__*/React.createElement(TableBody, null, upcomingData.map(invoice => /*#__PURE__*/React.createElement(Row, {
    isUpcoming: true,
    isStripeApi: store.account.featureFlagsStore.getIsStripeInvoicingApiEnabled,
    key: invoice.id,
    invoice: invoice,
    addresses: propertiesRespData,
    isAppfolio: store.company.companyFeatureStore.isAppfolio
  }))))))), selectedTab === 'other' && /*#__PURE__*/React.createElement(React.Fragment, null, store.invoice.filteredInvoices.length === 0 && (!store.account.featureFlagsStore.getIsStripeInvoicingApiEnabled || !(newInvoicesData !== null && newInvoicesData !== void 0 && newInvoicesData.length)) && /*#__PURE__*/React.createElement("div", {
    className: classes.notFound
  }, t('No invoices found')), (store.invoice.filteredInvoices.length > 0 || store.account.featureFlagsStore.getIsStripeInvoicingApiEnabled && (newInvoicesData === null || newInvoicesData === void 0 ? void 0 : newInvoicesData.length) > 0) && /*#__PURE__*/React.createElement("div", {
    className: classes.buildingsList
  }, /*#__PURE__*/React.createElement(TableContainer, {
    component: Paper
  }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null), /*#__PURE__*/React.createElement(TableCell, null, t('subscriptions.period_header')), /*#__PURE__*/React.createElement(TableCell, null, t('subscriptions.bill_period_header')), /*#__PURE__*/React.createElement(TableCell, null, t('subscriptions.invoice_number_header')), /*#__PURE__*/React.createElement(TableCell, null, t('subscriptions.payment_method_header')), /*#__PURE__*/React.createElement(TableCell, null, t('subscriptions.status_header')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('subscriptions.amount_header')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('subscriptions.refunded_header')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, t('subscriptions.toolbox')))), /*#__PURE__*/React.createElement(TableBody, null, (newInvoicesData === null || newInvoicesData === void 0 ? void 0 : newInvoicesData.length) > 0 && newInvoicesData.map(newInvoice => /*#__PURE__*/React.createElement(Row, {
    isStripeApi: store.account.featureFlagsStore.getIsStripeInvoicingApiEnabled,
    key: newInvoice.id,
    invoice: newInvoice,
    addresses: propertiesRespData,
    isAppfolio: store.company.companyFeatureStore.isAppfolio
  })), store.invoice.filteredInvoices.filter(invoice => {
    if (parseFloat(String(invoice.amountPaid).replace('$', '')) === 0) return false;
    if (invoice.invoiceNumber && newInvoicesData !== null && newInvoicesData !== void 0 && newInvoicesData.some(n => n.invoiceNumber === invoice.invoiceNumber)) return false;
    return true;
  }).map(invoice => /*#__PURE__*/React.createElement(Row, {
    key: invoice.id,
    invoice: invoice,
    addresses: propertiesRespData,
    isAppfolio: store.company.companyFeatureStore.isAppfolio
  })))))), store.invoice.getInvoicesV2LoadMoreAsync.inProgress && /*#__PURE__*/React.createElement("div", {
    className: classes.loader
  }, /*#__PURE__*/React.createElement(LinearProgress, null)), showIsLoad && /*#__PURE__*/React.createElement("div", {
    className: classes.paginationControllers
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => loadMore()
  }, "Load more")))));
});
export default InvoicesTab;